export const LogoMark = ({ className = "w-10 h-10" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" className={className} data-testid="logo-mark">
    <defs>
      <linearGradient id="gelvaroGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#00FF66" />
        <stop offset="50%" stopColor="#00E5FF" />
        <stop offset="100%" stopColor="#FF087B" />
      </linearGradient>
    </defs>
    <path
      d="M50 10c5 15 18 12 25 20s3 22 10 32-5 26-20 28-30-5-43-15-10-27-4-40 26-10 32-25z"
      fill="url(#gelvaroGrad)"
    />
    <circle cx="38" cy="42" r="7" fill="#FFFFFF" />
    <circle cx="62" cy="55" r="5" fill="#FFFFFF" />
    <path d="M30 68q20 14 40-3" stroke="#090D16" strokeWidth="4" strokeLinecap="round" fill="none" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark className={compact ? "w-8 h-8" : "w-10 h-10"} />
    <span className={`font-display tracking-wide text-white ${compact ? "text-2xl" : "text-3xl"}`}>
      GELVARO<span className="text-[#00FF66]">.</span>
    </span>
  </div>
);
